import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { InsuranceListResponse } from "@/features/insurance/types";
import { SHORT_LIVED_CACHE } from "@/lib/constants/cache";

import { getInsuranceList } from "../queryFunctions/getInsuranceList";
import { insuranceListKeys } from "../keyFactory";

type UseRawInsuranceListProps<TData = InsuranceListResponse> = {
  enabled?: boolean;
  select?: (data: InsuranceListResponse) => TData;
};

type InsuranceRawQueryOptions = UseQueryOptions<
  InsuranceListResponse,
  unknown,
  InsuranceListResponse,
  ReturnType<typeof insuranceListKeys.all>
>;

export function useRawInsuranceList<TData = InsuranceListResponse>({
  enabled = true,
  select,
}: UseRawInsuranceListProps<TData> = {}) {
  return useQuery({ ...optionFactory(), enabled, select });
}

function optionFactory() {
  return {
    queryFn: getInsuranceList,
    queryKey: insuranceListKeys.all(),
    refetchOnWindowFocus: false,
    staleTime: SHORT_LIVED_CACHE,
  } satisfies InsuranceRawQueryOptions;
}
